class EvsModule extends HTMLElement {
  constructor() {
    super();

    this.mediaGalleries = document.querySelectorAll("media-gallery");

    this.modules = this.closest("section").querySelectorAll("evs-module");

    this.colorSelectors = this.closest("section").querySelectorAll(
      "input[name='Colour']"
    );

    this.type = this.dataset.type;
    this.color = this.dataset.color;
    this.sectionId = this.dataset.sectionId;
    this.productId = this.dataset.productId;
    this.plus = this.querySelector("[data-quantity-plus]");
    this.minus = this.querySelector("[data-quantity-minus]");
    this.checkbox = this.querySelector("[data-selected]");
    this.quantitySelector = this.querySelector("[data-quantity-selector]");
    this.quantity = 1;
    this.quantityCounter = this.querySelector("[data-quantity-counter]");
    // this.quantityCounterLabel = this.querySelector(
    //   "[data-quantity-counter-label]"
    // );

    this.productFormCheckbox = document.querySelector(
      `[data-evs-module='${this.productId}'][data-evs-module-input='id']`
    );

    this.quantityInput = document.querySelector(
      `[data-evs-module='${this.productId}'][data-evs-module-input='quantity']`
    );

    if (this.plus)
      this.plus.addEventListener("click", this.onQuantityIncrease.bind(this));

    if (this.minus)
      this.minus.addEventListener("click", this.onQuantityDecrease.bind(this));

    this.checkbox.addEventListener("change", (e) =>
      this.onToggle(e.target.checked)
    );

    this.colorSelectors.forEach((colorSelector) =>
      colorSelector.addEventListener("click", () =>
        this.onColorChange(colorSelector.value)
      )
    );
  }

  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        this.classList.remove("evs-module--loading");
        setTimeout(() => {
          this.setupColorSelectors();
        }, 50);
      }
    );

    this.classList.remove("evs-module--loading");

    this.setupColorSelectors();
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();

    // Clean up color selector listeners
    this.cleanupColorSelectors();
  }

  cleanupColorSelectors() {
    if (this.colorSelectorListeners) {
      this.colorSelectorListeners.forEach(({ element, handler }) => {
        element.removeEventListener("click", handler);
      });
      this.colorSelectorListeners = null;
    }
  }

  setupColorSelectors() {
    // Clean up old listeners first
    this.cleanupColorSelectors();
    // Query color selectors fresh and setup new listeners
    const section = this.closest("section");
    if (!section) {
      return;
    }
    const colorSelectors = section.querySelectorAll("input[name='Colour']");
    this.colorSelectorListeners = [];
    colorSelectors.forEach((colorSelector) => {
      const handler = () => {
        this.onColorChange(colorSelector.value);
      };
      colorSelector.addEventListener("click", handler);
      this.colorSelectorListeners.push({ element: colorSelector, handler });
    });
  }

  onColorChange(color) {
    this.classList.add("evs-module--loading");

    this.checkbox.checked = false;
    this.productFormCheckbox.checked = false;
    this.quantityInput.checked = false;
    this.quantitySelector.classList.remove("visible");
    this.setQuantity(1);

    window.lastSelectedModule = null;

    if (this.color === color) this.classList.remove("hidden");
    else this.classList.add("hidden");
  }

  onToggle(checked) {
    this.productFormCheckbox.checked = checked;
    this.quantityInput.checked = checked;
    this.quantitySelector.classList[checked ? "add" : "remove"]("visible");

    if (!checked) {
      this.setQuantity(1);

      if (window.lastSelectedModule === this.productId)
        window.lastSelectedModule = this.dataset.sizeId;

      this.updateMediaGalleries(window.lastSelectedModule);
    } else {
      this.updateMediaGalleries();

      if (!window.lastSelectedModule)
        window.lastSelectedModule = this.productId;
    }
  }

  updateMediaGalleries(productId = this.productId) {
    this.mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.setActiveMedia(`${this.sectionId}-${productId}`, true);
    });

    const gallerythumbnails = document.querySelectorAll('[data-gallerythumbnail]');

    if (window.updateGallerythumbnail)
      gallerythumbnails.forEach(gallerythumbnail => {
        window.updateGallerythumbnail(gallerythumbnail);
      });
  }

  setQuantity(quantity) {
    this.quantity = quantity;
    this.quantityCounter.innerHTML = this.quantity;
    this.quantityInput.value = this.quantity;

    // if (this.quantity === 1) this.quantityCounterLabel.innerHTML = "Module";
    // else this.quantityCounterLabel.innerHTML = "Modules";
  }

  onQuantityIncrease() {
    this.quantity++;
    this.quantityCounter.innerHTML = this.quantity;
    this.quantityInput.value = this.quantity;
    // this.quantityCounterLabel.innerHTML = "Modules";
  }

  onQuantityDecrease() {
    if (this.quantity === 1) {
      this.checkbox.click();
      return;
    }

    this.quantity--;
    this.quantityCounter.innerHTML = this.quantity;
    this.quantityInput.value = this.quantity;

    // if (this.quantity === 1) this.quantityCounterLabel.innerHTML = "Module";
  }
}

if (!customElements.get("evs-module"))
  customElements.define("evs-module", EvsModule);
